import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuard } from "./shared/guards/auth.guard";
import { aiDashboardGuard } from "./shared/guards/ai-dashboard.guard";

const routes: Routes = [
  // Root → behaves like login (redirects based on authGuard)
  {
    path: "",
    loadChildren: () =>
      import("./screens/login/login.module").then((m) => m.LoginModule),
    canActivate: [authGuard(false)], // if logged in → /configuration/users
    pathMatch: "full",
  },
  {
    path: "management-reports",
    loadChildren: () =>
      import("./screens/management-reports/management-reports.module").then(
        (m) => m.ManagementReportsModule,
      ),
    canActivate: [authGuard(true)],
  },
  {
    path: "login",
    loadChildren: () =>
      import("./screens/login/login.module").then((m) => m.LoginModule),
    canActivate: [authGuard(false)],
  },
  {
    path: "configuration",
    loadChildren: () =>
      import("./screens/user-access/user-access.module").then(
        (m) => m.UserAccessModule,
      ),
  },
  {
    path: "data-input",
    loadChildren: () =>
      import("./screens/data-input/data-input.module").then(
        (m) => m.DataInputModule,
      ),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./screens/home/home.module").then((m) => m.HomeModule),
    canActivate: [authGuard(true)],
  },
  {
    path: "partners",
    loadChildren: () =>
      import("./screens/partners/partners.module").then(
        (m) => m.PartnersModule,
      ),
    canActivate: [authGuard(true)],
  },
  {
    path: "ai-overview",
    loadChildren: () =>
      import("./screens/ai/ai-overview/ai-overview.module").then(
        (m) => m.AiOverviewModule,
      ),
    canActivate: [authGuard(true), aiDashboardGuard],
  },
  {
    path: "financial-statements",
    loadChildren: () =>
      import("./screens/financial-statement/financial-statement.module").then(
        (m) => m.FinancialStatementModule,
      ),
    canActivate: [authGuard(true)],
  },
  {
    path: "accounting",
    loadChildren: () =>
      import("./screens/accounting/accounting.module").then(
        (m) => m.AccountingModule,
      ),
    canActivate: [authGuard(true)],
  },
  {
    path: "projections",
    loadChildren: () =>
      import("./screens/projections/projections.module").then(
        (m) => m.ProjectionsModule,
      ),
    canActivate: [authGuard(true)],
  },
  {
    path: "calculator",
    loadChildren: () =>
      import("./screens/calculator/calculator.module").then(
        (m) => m.CalculatorModule,
      ),
    canActivate: [authGuard(true)],
  },
  {
    path: "version",
    loadComponent: () =>
      import("./screens/generic/version/version.component").then(
        (m) => m.VersionComponent,
      ),
    canActivate: [authGuard(true)],
  },
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
